import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_last_invoice_line_by_invoiceIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { invoiceId?: number }): 
  Promise<{ result: { Id?: number, InvoiceId?: number, LineNumber?: number } }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_last_invoice_line_by_invoiceId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      invoiceId?: number    }) {
      return false;
    }
}
